const GLOBAL_LOCALES = require('./global.json');

module.exports = GLOBAL_LOCALES;
